import {
  ListItemAvatar,
  type ListItemProps,
  ListItemText,
  useTheme,
} from '@mui/material';
import { UserAutocompleteListItem } from './UserAutocompleteOption';
import generateColorForName, {
  ColorDerivationStrategy,
} from '../../../../../../../../../UserAvatar/generateColorForName';
import ColoredAvatar from '@/components/UserAvatar/ColoredAvatar';

type DirectInviteEmailOptionProps = ListItemProps & {
  email: string;
};

const DirectInviteEmailOption = ({
  email,
  ...props
}: DirectInviteEmailOptionProps) => {
  const avatarColor = generateColorForName(
    email,
    ColorDerivationStrategy.FIRST_CHAR,
  );

  const theme = useTheme();
  const avatarColorShade = theme.isDark ? 200 : 600;

  return (
    <UserAutocompleteListItem dense {...props} disablePadding>
      <ListItemAvatar>
        <ColoredAvatar color={avatarColor[avatarColorShade]} size={32}>
          {email.charAt(0)}
        </ColoredAvatar>
      </ListItemAvatar>
      <ListItemText primary={email} />
    </UserAutocompleteListItem>
  );
};

export default DirectInviteEmailOption;
